import React from 'react';

const Volume = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" 
        x="0px" 
        y="0px" 
        viewBox="0 0 477.526 477.526" 
        space="preserve">

            <g>
                <path 
                    fill="currentColor"
                    d="M213.333,104.493c-5.28-3.049-11.786-3.049-17.067,0L80.794,170.456H17.067C7.641,170.456,0,178.097,0,187.522v102.4    c0,9.426,7.641,17.067,17.067,17.067h63.727l115.541,66.014c8.185,4.675,18.609,1.83,23.284-6.354    c1.472-2.577,2.246-5.492,2.247-8.46V119.256C221.86,113.165,218.608,107.539,213.333,104.493z M187.733,328.766l-93.867-53.658    c-2.598-1.486-5.541-2.263-8.533-2.253h-51.2v-68.267h51.2c2.993,0.01,5.936-0.767,8.533-2.253l93.867-53.658V328.766z"/>
            </g>

            <g>
                <path 
                    fill="currentColor"
                    d="M286.362,176.821c-5.909-7.331-16.639-8.492-23.979-2.594c-7.347,5.904-8.517,16.647-2.613,23.994    c0,0,0.001,0.001,0.001,0.002c17.649,24.115,17.649,56.883,0,80.998c-5.95,7.31-4.847,18.06,2.463,24.01    c7.31,5.95,18.06,4.847,24.01-2.463c0.039-0.048,0.078-0.096,0.117-0.145C314.284,264.079,314.284,213.366,286.362,176.821z"/>
            </g>

            <g>
                <path 
                    fill="currentColor"
                    d="M354.628,125.622c-5.909-7.331-16.639-8.492-23.979-2.594c-7.347,5.904-8.517,16.647-2.612,23.994    c0,0.001,0.001,0.001,0.001,0.002c40.653,54.374,40.653,129.024,0,183.398c-5.95,7.31-4.847,18.06,2.463,24.01    c7.31,5.95,18.06,4.847,24.01-2.463c0.039-0.048,0.078-0.096,0.117-0.145C404.771,284.759,404.771,192.686,354.628,125.622z"/>
            </g>

            <g>
                <path 
                    fill="currentColor"
                    d="M422.895,74.422c-5.909-7.331-16.639-8.492-23.979-2.594c-7.347,5.904-8.517,16.647-2.612,23.994    c0,0.001,0.001,0.001,0.001,0.002c63.352,84.734,63.352,201.065,0,285.798c-5.95,7.31-4.847,18.06,2.463,24.01    c7.31,5.95,18.06,4.847,24.01-2.463c0.039-0.048,0.078-0.096,0.117-0.145C495.736,305.599,495.736,171.845,422.895,74.422z"/>
            </g>
            
        </svg>
    );
}

export default Volume;
